module.exports = __webpack_public_path__ + "img/personal_data_ad.20520876.png";